import React, { useState } from 'react';
import { getTranslatedText, useIntl } from '@nile/components';
import { ToggleButton } from '@superops/ui-design-system';
import styled from 'styled-components';
import WarningModal from './FieldsTable/WarningModal';

const PermissionToggle = (props) => {
  const {
    showToClients,
    setShowToClients,
    mandatoryOnCreation,
    setMandatoryOnCreation,
    mandatoryOnClosure,
    setMandatoryOnClosure,
    disableEdit,
    hideMandatoryOnCreation,
    showWarning,
    hideShowToClients,
    hideMandatoryOnClosure
  } = props;
  const intl = useIntl();

  const PermissionToggleWrapper = styled.div`
    display: flex;
    flex-direction: ${(prop) => prop?.flexDirection || 'column'};
    gap: ${(prop) => prop?.gap || '40px'};

    .toggle-parent {
      display: flex;
      gap: 10px;
      align-items: center;
    }
    .title {
      margin-bottom: 15px;
      font-weight: 600;
      color: #000000;
    }
  `;

  const [modalActive, setModalActive] = useState(false);
  const [propertyToUpdate, setPropertyToUpdate] = useState({
    state: null,
    setState: null
  });

  const propertyByRef = React.useRef(null);
  propertyByRef.current = propertyToUpdate;

  const updateToggle = (state, setState) => {
    if (showWarning) {
      setModalActive(true);
      setModalActive(true);
      setPropertyToUpdate({
        state: state,
        setState: setState
      });
    } else {
      setState(!state);
    }
  };

  return (
    <>
      <PermissionToggleWrapper
        gap={props.gap}
        flexDirection={props.flexDirection}
      >
        {!hideShowToClients && (
          <>
            <div className="toggle-wrapper">
              <p className="title">
                {getTranslatedText(
                  intl,
                  'admin.customFieldForm.heading.permissions'
                )}
              </p>

              <div className="toggle-parent">
                <ToggleButton
                  onChange={() => updateToggle(showToClients, setShowToClients)}
                  value={showToClients}
                  locked={disableEdit}
                  size="small"
                />
                <p className="toggle-text">
                  {getTranslatedText(
                    intl,
                    'admin.customFieldForm.toggle.showToRequesters'
                  )}
                </p>
              </div>
            </div>
          </>
        )}

        <div className="toggle-wrapper">
          {!hideMandatoryOnCreation && !hideMandatoryOnClosure && (
            <p className="title">
              {getTranslatedText(intl, 'admin.customFieldForm.title.mandatory')}
            </p>
          )}

          {!hideMandatoryOnCreation && (
            <>
              <div className="toggle-parent mb10">
                <ToggleButton
                  onChange={() =>
                    updateToggle(mandatoryOnCreation, setMandatoryOnCreation)
                  }
                  value={mandatoryOnCreation}
                  locked={disableEdit}
                  size="small"
                />
                <p className="toggle-text">
                  {getTranslatedText(
                    intl,
                    'admin.customFieldForm.toggle.mandatoryCreating'
                  )}
                </p>
              </div>
            </>
          )}

          {!hideMandatoryOnClosure && (
            <>
              <div className="toggle-parent">
                <ToggleButton
                  onChange={() =>
                    updateToggle(mandatoryOnClosure, setMandatoryOnClosure)
                  }
                  value={mandatoryOnClosure}
                  locked={disableEdit}
                  size="small"
                />
                <p className="toggle-text">
                  {getTranslatedText(
                    intl,
                    'admin.customFieldForm.toggle.mandatoryClosure'
                  )}
                </p>
              </div>
            </>
          )}
        </div>

        <WarningModal
          modalActive={modalActive}
          setModalActive={setModalActive}
          value={propertyByRef.current.state}
          setValue={propertyByRef.current.setState}
        />
      </PermissionToggleWrapper>
    </>
  );
};

export default PermissionToggle;
